import React from 'react';
import './App.css';
import './container/CordiiTCreative.css';
import './container/altmedia.css';
import CordiiTCreative from './container/CordiiTCreative';

function App() {
  return (
    <CordiiTCreative></CordiiTCreative>
  );
}

export default App;
